// Lo que dicen las tarjetas del asistente sobre este módulo, en los cuatro
// idiomas: `comms.assistant.send.*`. El backend manda la clave y el texto en
// inglés (§16, backend/assistant.js); la tarjeta lo dice en el idioma de quien
// la lee. Es un contrato con ese fichero: una clave que cambia aquí cambia allí.

export default {
  es: {
    send: {
      summary: {
        named: 'Enviar «{text}» a {conversation}',
        conversation: 'Enviar «{text}» a la conversación',
        person: 'Enviar «{text}» a {person}',
        colleague: 'Enviar «{text}» a un compañero',
      },
      action: 'Enviar un mensaje',
      field: { to: 'Para', text: 'Mensaje' },
      value: { unknown: 'Una conversación en la que quizá no puedas escribir' },
      where: 'Conversación',
      note: { unknown: 'Revisa a quién va antes de enviarlo' },
      outcome: 'Mensaje enviado',
    },
  },
  ca: {
    send: {
      summary: {
        named: 'Enviar «{text}» a {conversation}',
        conversation: 'Enviar «{text}» a la conversa',
        person: 'Enviar «{text}» a {person}',
        colleague: 'Enviar «{text}» a un company',
      },
      action: 'Enviar un missatge',
      field: { to: 'Per a', text: 'Missatge' },
      value: { unknown: 'Una conversa on potser no pots escriure' },
      where: 'Conversa',
      note: { unknown: 'Revisa a qui va abans d’enviar-lo' },
      outcome: 'Missatge enviat',
    },
  },
  en: {
    send: {
      summary: {
        named: 'Send “{text}” to {conversation}',
        conversation: 'Send “{text}” to the conversation',
        person: 'Send “{text}” to {person}',
        colleague: 'Send “{text}” to a colleague',
      },
      action: 'Send a message',
      field: { to: 'To', text: 'Message' },
      value: { unknown: 'A conversation you may not be able to write in' },
      where: 'Conversation',
      note: { unknown: 'Check who it goes to before sending' },
      outcome: 'Message sent',
    },
  },
  fr: {
    send: {
      summary: {
        named: 'Envoyer « {text} » à {conversation}',
        conversation: 'Envoyer « {text} » à la conversation',
        person: 'Envoyer « {text} » à {person}',
        colleague: 'Envoyer « {text} » à un collègue',
      },
      action: 'Envoyer un message',
      field: { to: 'À', text: 'Message' },
      value: { unknown: 'Une conversation où vous ne pouvez peut-être pas écrire' },
      where: 'Conversation',
      note: { unknown: 'Vérifiez le destinataire avant d’envoyer' },
      outcome: 'Message envoyé',
    },
  },
}
